<!-- Autopay modal -->
@if (loaderIconTD | async) {
  <app-loader [isEmvAutopay]="true" [initiatedVoidCC]="initiatedVoidCC" [initiatedStripEMVPayment] ="initiatedStripEMVPayment" [stripeLoader] ="stripeLoader" (emitPaymentTerminalStatus)="emitPaymentTerminalStatus($event)"
  [isTDEmv]="isTDEmv"></app-loader>
}
@if (loaderIconAuto | async) {
  <app-loader></app-loader>
}
@if (isLoaderActive ) {
  <app-loader></app-loader>
}
<div bsModal #AutoPayModalRef="bs-modal" [config]="modalConfig" class="modal fade" [hidden]="IsmodelShow" id="AutoPayModal" tabindex="-1" role="dialog">
  <!-- <div class="modal fade" [hidden]="IsmodelShow" id="AutoPayModal" tabindex="-1" role="dialog"> -->
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mb-0 text-start">Autopay / Card on File</h5>
        <button type="button" class="close" id="autopayClose-button" aria-label="Close"
          [disabled]="disableCancelButton || isPayFieldsEnrollmentPending" (click)="cancelAndCloseModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ptb24">
        <div class="row">
          <div class="col-md-4">
            <div class="row mx-0">
              <label class="pure-material-checkbox mb-0">
                <input type="checkbox" class="custom-control-input" (change)="changeEnableAutoPay($event)"
                  [(ngModel)]="checkautoPay"
                  [disabled]="(this.autopayInfoForUnit?.Mode == 'EFT' && this.checkautoPay && paymentGateWay != EPaymentGateway.Stripe) || disableFieldsForHistory() || isAutoPayRequired">
                  <span>Enable Autopay</span>
                </label>
              </div>
              @if (viewRightAutoCCProcessDay) {
                <div class="row mx-0 pl-31 mt-4">
                  <label>Autopay Processing Day</label>
                  <select class="form-select w-75" [(ngModel)]="autoCCDays"
                    [disabled]="!checkautoPay || !editRightAutoCCProcessDay || disableFieldsForHistory()">
                    <option>0</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                    <option>13</option>
                    <option>14</option>
                    <option>15</option>
                    <option>16</option>
                    <option>17</option>
                    <option>18</option>
                    <option>19</option>
                    <option>20</option>
                    <option>21</option>
                    <option>22</option>
                    <option>23</option>
                    <option>24</option>
                    <option>25</option>
                    <option>26</option>
                    <option>27</option>
                    <option>28</option>
                    <option>29</option>
                    <option>30</option>
                    <option>31</option>
                  </select>
                </div>
              }
              <div class="row mx-0 pl-31 mt-4">
                <label class="pure-material-checkbox mb-0">
                  <input type="checkbox" [disabled]="!checkautoPay || disableFieldsForHistory()" [(ngModel)]="email">
                  <span>Email Autopay Receipt</span>
                </label>
              </div>
              <div class="row mx-0 pl-31 mt-3">
                <label class="pure-material-checkbox mb-0">
                  <input type="checkbox" [disabled]="!checkautoPay || disableFieldsForHistory()"
                    [(ngModel)]="printAutopay">
                    <span>Print Autopay Receipt</span>
                  </label>
                </div>
              </div>

              @if (isUnitSelected()) {
                <div class="col-md-4 pl-0">
                  <div class="userDetails">
                    <table class="userDetailsTbl">
                      <tr>
                        <td>Mode</td>
                        <td>:</td>
                        <td>{{autopayInfoForUnit?.Mode}}</td>
                      </tr>
                      <tr>
                        <td>Card #/Acc #</td>
                        <td>:</td>
                        <td>{{autopayInfoForUnit?.AccountNumber}}</td>
                      </tr>
                      <tr>
                        <td>Card Type/Acc Type</td>
                        <td>:</td>
                        <td>{{autopayInfoForUnit?.CardTypeName}}</td>
                      </tr>
                      <tr>
                        <td>Card Exp.</td>
                        <td>:</td>
                        <td>{{autopayInfoForUnit?.CardExpiryDate }}</td>
                      </tr>
                      <tr>
                        <td>Name on Card</td>
                        <td>:</td>
                        <td>{{autopayInfoForUnit?.NameOnCard}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              }

              <div class="col-md-4 pt-3 pt-md-0">
                <div class="row mx-0">
                  <label>Mode</label>
                  <select class="form-select" id="modeSelect" [(ngModel)]="modeSelect" value="0"
                    (change)="showForm($event)" [disabled]="disableFieldsForHistory() || isPayFieldsEnrollmentPending || showPayFieldsCardOnFileForm">
                    <option value="0" selected="selected">Select</option>
                    <option value="CardTerminal" [disabled]="disableModeOption('1')">Add Card On Terminal</option>
                    <option value="CardWebsite" [disabled]="disableModeOption('2')">Add Card On Websites</option>
                    <option value="ACH" [disabled]="disableModeOption('3')"> ACH</option>
                    <option value="EFT" [disabled]="disableModeOption('4')">EFT</option>
                  </select>
                </div>

                @if (CardTerminalForm && process) {
                  <div id="CardTerminal">
                    <div class="payment_successful_txt">
                      <app-success-tick></app-success-tick><span>Processed Successfully</span>
                    </div>
                  </div>
                }
                @if (CardTerminalForm && autopayFailed) {
                  <div class="payment_failed_txt">
                    <app-failure-cross></app-failure-cross><span>Enabling of Autopay Failed</span>
                    @if (CardTerminalForm && autopayFailed) {
                      <div class="payment_fail_reason">
                        <ul>
                          <li>
                            <label class="fw-bold">{{autopayFailReason}}</label>
                          </li>
                        </ul>
                      </div>
                    }
                    @if (isStripeResetTerminal) {
                      <button type="button" class="btn btn-primary" style="float: right;" (click)="resetStripeTerminal()">Reset Device</button>
                    }
                  </div>
                }
                @if (CardWebsiteForm && process) {
                  <div id="CardWebsite">
                    <div class="payment_successful_txt">
                      <app-success-tick></app-success-tick><span>Processed Successfully</span>
                    </div>
                  </div>
                }
                @if ((CardWebsiteForm || ACHForm) && autopayFailed) {
                  <div class="payment_failed_txt">
                    <app-failure-cross></app-failure-cross><span>Enabling of Autopay Failed</span>
                    @if ((CardWebsiteForm || ACHForm) && autopayFailed) {
                      <div class="payment_fail_reason">
                        <ul>
                          <li>
                            <label class="fw-bold">{{autopayFailReason}}</label>
                          </li>
                        </ul>
                      </div>
                    }
                  </div>
                }
                @if (ACHForm && process) {
                  <div id="ACH">
                    <div class="payment_successful_txt">
                      <app-success-tick></app-success-tick><span>Processed Successfully</span>
                    </div>
                  </div>
                }
                <form #Eftcustomerform="ngForm">
                  @if (EFTForm && paymentGateWay != EPaymentGateway.Stripe) {
                    <div id="EFT">
                      <div class="row mx-0 mt-3">
                        <label>Account Holder Name @if (isRequired('AccountName')) {
                          <span class="required">*</span>
                        }</label>
                        <input type="text" class="form-control" [(ngModel)]="Accountname" maxlength="35" name="AccountName"
                          #AccountName="ngModel">
                          @if (Eftcustomerform.form.get('AccountName').errors  &&
                            (Eftcustomerform.form.get('AccountName').dirty || Eftcustomerform.form.get('AccountName').touched) &&
                            Eftcustomerform.form.get('AccountName').validator !== null) {
                            <div class="alert alert-danger">
                              @if (Eftcustomerform.form.get('AccountName').errors.required) {
                                <span>
                                Account Holder Name is required</span>
                              }
                            </div>
                          }
                        </div>
                        <div class="row mx-0 mt-3">
                          <label>Bank Code @if (isRequired('Bankcode')) {
                            <span class="required">*</span>
                          }</label>
                          <input type="text" class="form-control" [(ngModel)]="bankcode" maxlength="4" name="Bankcode"
                            #Bankcode="ngModel">
                            @if (Eftcustomerform.form.get('Bankcode').errors  &&
                              (Eftcustomerform.form.get('Bankcode').dirty || Eftcustomerform.form.get('Bankcode').touched) &&
                              Eftcustomerform.form.get('Bankcode').validator !== null) {
                              <div class="alert alert-danger">
                                @if (Eftcustomerform.form.get('Bankcode').errors.required) {
                                  <span>
                                  Bank code is required</span>
                                }
                              </div>
                            }
                          </div>
                          <div class="row mx-0 mt-3">
                            <label>Transit Number @if (isRequired('TransitNo')) {
                              <span class="required">*</span>
                            }</label>
                            <input type="text" class="form-control" [(ngModel)]="transitNo" maxlength="5" name="TransitNo"
                              #TransitNo="ngModel">
                              @if (Eftcustomerform.form.get('TransitNo').errors  &&
                                (Eftcustomerform.form.get('TransitNo').dirty || Eftcustomerform.form.get('TransitNo').touched) &&
                                Eftcustomerform.form.get('TransitNo').validator !== null) {
                                <div class="alert alert-danger">
                                  @if (Eftcustomerform.form.get('TransitNo').errors.required) {
                                    <span>
                                    Transit Number is required</span>
                                  }
                                </div>
                              }
                            </div>
                            <div class="row mx-0 mt-3">
                              <label>Account Number @if (isRequired('AccoutNo')) {
                                <span class="required">*</span>
                              }</label>
                              <input type="text" class="form-control" [(ngModel)]="Accountnumber" maxlength="12" name="AccoutNo"
                                #AccoutNo="ngModel">
                                @if (Eftcustomerform.form.get('AccoutNo').errors  &&
                                  (Eftcustomerform.form.get('AccoutNo').dirty || Eftcustomerform.form.get('AccoutNo').touched) &&
                                  Eftcustomerform.form.get('AccoutNo').validator !== null) {
                                  <div class="alert alert-danger">
                                    @if (Eftcustomerform.form.get('AccoutNo').errors.required) {
                                      <span>
                                      Account Number is required</span>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </form>
                      </div>
                    </div>
                    @if (showHistorySection('history')) {
                      <div class="row mx-0 mt-2">
                        <div class="col-md-12 history-border">
                          <div class="row">
                            <div class="autopayhistoryheader" style="justify-content: space-between;">
                              <h5 class="modal-title mb-0 text-start mt-1" style="font-size: 16px;">Autopay History</h5>
                              <div style="display: inline-flex;">
                                <button type="button" class="btn btn-primary me-2 btnautopay" (click)="printAutopayHistory()"
                                [disabled]="disablePrintExport()">Print</button>
                                <button type="button" class="btn btn-primary btnautopay" (click)="exportAutopayHistory()"
                                [disabled]="disablePrintExport()">Export</button>
                              </div>
                            </div>
                          </div>
                          <div class="row w-50 d-inline-flex mt-4 mx-0">
                            <label class="mt-2 me-2">Unit #</label>
                            <div style="width: 83%;">
                              <select class="form-select" [(ngModel)]="selectedUnitLease"
                                (change)="onUnitChange($event.target.value, false)">
                                @if (autoPayHistory.length > 1) {
                                  <option value="0" selected="selected">All</option>
                                }
                                @for (tu of autoPayHistory; track tu) {
                                  <option [value]="tu.LeaseNo">{{tu.UnitNo}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="row mt-4">
                            <div class="scroll_outer" style="overflow-x: auto;">
                              <div class="scroll_inner_950" style="width: 1562px;">
                                <ejs-grid #gridCallsbyempData class="historytable table-striped" height="120"
                                  [dataSource]='autopayHistoryForUnit' allowFiltering='true' [filterSettings]='filterSettings'
                                  [textWrapSettings]="wrapSettings" allowTextWrap="true">
                                  <e-columns>
                                    <e-column field='FormattedTransactionDate' headerText='Transaction Date' type='string'
                                      textAlign='left' width=80>
                                    </e-column>
                                    <e-column field='TransactionTypeValue' headerText='Transaction Type' type='string'
                                      textAlign='Left' width=50>
                                    </e-column>
                                    <e-column field='OrderId' headerText='Order Id' textAlign='center' width=85>
                                    </e-column>
                                    <e-column field='PaymentModeName' headerText='Payment Mode' textAlign='center' width=80>
                                    </e-column>
                                    <e-column field='Amount' headerText='Amount' textAlign='center' width=50>
                                      <ng-template #template let-data>
                                        <span class="dataName">{{data.Amount | currency:'USD'}}</span>
                                      </ng-template>
                                    </e-column>
                                    <e-column field='CardNumber' headerText='Card #' textAlign='center' width=40>
                                    </e-column>
                                    <e-column field='AuthCode' headerText='Auth Code' textAlign='center' width=90>
                                    </e-column>
                                    <e-column field='BatchNumber' headerText='Batch #' textAlign='center' width=75>
                                    </e-column>
                                    <e-column field='ResponseCode' headerText='Response Code' textAlign='center' width=55>
                                    </e-column>
                                    <e-column field='Status' headerText='Status' textAlign='center' width=80>
                                    </e-column>
                                  </e-columns>
                                </ejs-grid>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary me-3" (click)="cancelAndCloseModal()"
                    [disabled]="disableCancelButton">Cancel</button>
                    @if (showHistorySection('delete')) {
                      <button type="button" class="btn btn-primary" (click)="onDeleteAutoPayClick(templateDeleteAutopay)"
                      [disabled]="disableAutopayDelete()">Delete</button>
                    }
                    <button type="button" class="btn btn-primary" [disabled]="disableAutopaySave()"
                    (click)="saveAndCloseModal()">Save</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Autopay modal end // -->

            <div bsModal #AliaseIFrame="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
              aria-labelledby="dialog-sizes-name1">
              <div class="modal-dialog modal-dialog-centered  modal-lg modal-xxl">
                <div class="modal-content">
                  <div class="modal-body-autopay h-100">

                    <!--Host Pay ALIAS starts-->
                    @if (showAliasIFrame) {
                      <div class="third_party_payment">
                        <iframe width="100%" #CNPAliasIFrame id="CNPAliasIFrame" style="min-height: 60vh" height="100%"
                        frameBorder="0" [src]="urlSafeAlias" (load)="getHiddenInputAlias()"></iframe>
                        <div
                          [ngClass]="customerInfoPresent ? 'row my-3 me-5 ms-5 autopay-footer' : 'row my-3 justify-content-end mx-0'">
                          @if (customerInfoPresent) {
                            <label class="pure-material-checkbox float-left">
                              <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
                                (change)="onClickAutoPopulateBillingInfo(209)">
                                <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                              </label>
                            }
                            <div class="pay_rgt_butt">
                              <button type="button" class="btn btn-outline-primary" (click)="onhstPayAliasBtn()">Cancel</button>
                            </div>
                          </div>
                        </div>
                      }
                      <!--Host Pay ALIAS ends-->

                      <!--Host Pay ALIAS starts-->
                      @if (!showAliasIFrame) {
                        <div class="third_party_payment">
                          <iframe width="100%" #CNPAliasIFrameTD id="CNPAliasIFrameTD" style="min-height: 60vh" height="100%"
                          frameBorder="0" src="" (load)="getTDCustomerId(CNPAliasIFrameTD)"></iframe>
                          <div class="row my-3 justify-content-end mx-0 ">
                            <div class="pay_rgt_butt">
                            </div>
                          </div>
                        </div>
                      }
                      <!--Host Pay ALIAS ends-->
                    </div>
                  </div>
                </div>
              </div>

              @if (showPayFieldsCardOnFileForm) {
                <div class="payfields-embedded-shell">
                  <div #payFieldsCardOnFileDialog class="payfields-embedded-content" role="dialog" aria-modal="true" aria-labelledby="payFieldsCardOnFileModalTitle" tabindex="-1" (keydown.escape)="$event.stopPropagation(); onPayFieldsCardOnFileCancel()">
                    <div class="payfields-embedded-header">
                      <h5 id="payFieldsCardOnFileModalTitle">Card on File</h5>
                      <button type="button" class="payfields-close-btn" (click)="onPayFieldsCardOnFileCancel()" [disabled]="isPayFieldsEnrollmentPending" aria-label="Close">&times;</button>
                    </div>
                    <div class="payfields-embedded-body">
                      <h4 class="payfields-embedded-title">Card Information</h4>
                      <div class="payfields-embedded-field-row">
                        <label>Card Number:<span class="required">*</span></label>
                        <div id="payfields-cof-card-number" class="payfields-secure-field"></div>
                      </div>
                      <div class="payfields-embedded-field-row payfields-expiry-cvv">
                        <div>
                          <label>Expiry Date:<span class="required">*</span></label>
                          <div id="payfields-cof-card-expiration" class="payfields-secure-field"></div>
                        </div>
                        <div>
                          <label>CVV:<span class="required">*</span></label>
                          <div id="payfields-cof-card-cvv" class="payfields-secure-field"></div>
                        </div>
                      </div>

                      <h4 class="payfields-embedded-title">Customer Information</h4>
                      <div class="payfields-embedded-grid">
                        <div>
                          <label>First Name:<span class="required">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.firstName" maxlength="50" />
                        </div>
                        <div>
                          <label>Middle Name:</label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.middleName" maxlength="50" />
                        </div>
                        <div>
                          <label>Last Name:<span class="required">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.lastName" maxlength="50" />
                        </div>
                        <div>
                          <label>Company Name:</label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.companyName" maxlength="100" />
                        </div>
                        <div>
                          <label>Address One:<span class="required">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.addressOne" maxlength="100" />
                        </div>
                        <div>
                          <label>Address Two:</label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.addressTwo" maxlength="100" />
                        </div>
                        <div>
                          <label>City:<span class="required">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.city" maxlength="50" />
                        </div>
                        <div>
                          <label>Country:</label>
                          <select class="form-select" [(ngModel)]="payFieldsCardOnFileBillingDetails.countryId" (change)="onPayFieldsCardOnFileCountryChange($event.target.value)">
                            <option [ngValue]="0">Select</option>
                            @for (ct of countryList; track ct) {
                              <option [value]="ct.Id">{{ct.Name}}</option>
                            }
                          </select>
                        </div>
                        <div>
                          <label>State or Province:<span class="required" *ngIf="payFieldsStateRequired && !emptyStateList">*</span></label>
                          <select class="form-select" [(ngModel)]="payFieldsCardOnFileBillingDetails.stateId" [disabled]="emptyStateList">
                            <option value="0">--</option>
                            @for (st of stateList; track st) {
                              <option [value]="st.Id">{{st.Name}}</option>
                            }
                          </select>
                        </div>
                        <div>
                          <label>Postal Code:<span class="required">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="payFieldsCardOnFileBillingDetails.postalCode" maxlength="15" />
                        </div>
                      </div>
                    </div>
                    <div class="payfields-embedded-sticky-footer">
                      <div class="payfields-embedded-actions">
                        @if (customerInfoPresent) {
                          <label class="pure-material-checkbox mb-0 me-auto">
                            <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo" (change)="onPayFieldsCardOnFileAutoPopulateChange()">
                            <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                          </label>
                        }
                        <button type="button" class="btn btn-outline-primary" (click)="onPayFieldsCardOnFileCancel()" [disabled]="isPayFieldsEnrollmentPending">Cancel</button>
                        <button type="button" class="btn btn-primary" (click)="submitPayFieldsCardOnFileForm()" [disabled]="isPayFieldsCardOnFileSubmitDisabled()">{{CCPlaceHolder}}</button>
                      </div>
                    </div>
                    <div id="payfields-cof-submit-host" class="payfields-submit-host"></div>
                  </div>
                </div>
              }

              <!-- Bambora Custom Checkout Start-->
              <ng-template #showTDHostedForm>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Autopay / Card On File</h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="ontTDHostedCancel()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form id="checkout-form" class="text-center">
                    <div>
                      <div class="form-group col-xs-6 has-feedback" id="card-number-bootstrap">
                        <div id="card-number" class="form-control"></div>
                        <label class="help-block" for="card-number" id="card-number-error"></label>
                      </div>
                      <div class="form-group col-xs-6"></div>
                    </div>
                    <div>
                      <div class="form-group col-xs-2 has-feedback" id="card-cvv-bootstrap">
                        <div id="card-cvv" class="form-control"></div>
                        <label class="help-block" for="card-cvv" id="card-cvv-error"></label>
                      </div>
                      <div class="form-group col-xs-10"></div>
                    </div>
                    <div>
                      <div class="form-group col-xs-2 has-feedback" id="card-expiry-bootstrap">
                        <div id="card-expiry" class="form-control"></div>
                        <label class="help-block" for="card-expiry" id="card-expiry-error"></label>
                      </div>
                      <div class="form-group col-xs-10"></div>
                    </div>
                    <div class="col-xs-2 text-center">
                      <button #payButton id="pay-button" type="submit" class="btn btn-primary disabled" disabled="true"
                      hidden="true">Pay</button>
                    </div>
                  </form>
                  <div class="col-xs-2 text-center">
                    <button #BtnPay id="BtnPay" class="btn btn-primary disabled" hidden="true"
                    (click)="generateInitialCCT()">Pay</button>
                    <button #BtnError id="BtnError" class="btn btn-primary disabled" hidden="true"
                    (click)="callOnTokenError()">Pay</button>
                    <input #txtTransactionId id="txtTransactionId" type="text" hidden="true" />
                    <input #isTDFormValid id="isTDFormValid" hidden="true" type="text" />
                    <input #customCardDetails id="customCardDetails" hidden="true" type="text" />
                    <input #cardTypeTD id="cardTypeTD" hidden="true" type="text" />
                    <div id="feedback"></div>
                  </div>
                  <div class="row mx-0">
                    <input type="text" class="form-control" placeholder="Name On Card" [(ngModel)]="tdNameOnCard" required
                      maxlength="30" #noc="ngModel" />
                      @if (noc.errors && noc.touched) {
                        <div>
                          @if (noc.errors.required) {
                            <div>Name on Card is required.</div>
                          }
                        </div>
                      }
                    </div>
                    @if (fieldsRequired) {
                      <div>
                        <div class="row mx-0 mt-3">
                          <h6>Billing Information:</h6>
                        </div>
                        <div class="row mt-3">
                          @if (isMandatory('tdFName')) {
                            <div class="form-group col-md-6">
                              <label>First Name<span class="required">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="tdFName" maxlength="15" required #fnm="ngModel"
                                (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                @if (fnm.errors && fnm.touched) {
                                  <div>
                                    @if (fnm.errors.required) {
                                      <div>First Name is required.</div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (isMandatory('tdLName')) {
                              <div class="form-group col-md-6">
                                <label>Last Name<span class="required">*</span></label>
                                <input type="text" class="form-control" [(ngModel)]="tdLName" maxlength="15" required #lnm="ngModel"
                                  (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                  @if (lnm.errors && lnm.touched) {
                                    <div>
                                      @if (lnm.errors.required) {
                                        <div>Last Name is required.</div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            <div class="row mt-3">
                              @if (isMandatory('tdAddress')) {
                                <div class="form-group col-md-6">
                                  <label>Address<span class="required">*</span></label>
                                  <input type="text" class="form-control" [(ngModel)]="tdAddress" maxlength="50" required #add="ngModel"
                                    (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                    @if (add.errors && add.touched) {
                                      <div>
                                        @if (add.errors.required) {
                                          <div>Address is required.</div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                @if (isMandatory('tdCity')) {
                                  <div class="form-group col-md-6">
                                    <label>City<span class="required">*</span></label>
                                    <input type="text" class="form-control" [(ngModel)]="tdCity" maxlength="15" required #noc="ngModel"
                                      (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                      @if (noc.errors && noc.touched) {
                                        <div>
                                          @if (noc.errors.required) {
                                            <div>City is required.</div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="row mt-3">
                                  @if (isMandatory('tdCountry')) {
                                    <div class="form-group col-md-6">
                                      <label>Country<span class="required">*</span></label>
                                      <select id="inputcountry" class="form-select" [(ngModel)]="tdCountry"
                                        (change)="onCountryChange($event.target.value, 1)">
                                        @for (ct of countryList; track ct) {
                                          <option [value]="ct.Id">{{ct.Name}}</option>
                                        }
                                      </select>
                                    </div>
                                  }
                                  @if (isMandatory('tdState')) {
                                    <div class="form-group col-md-6">
                                      <label>State@if (!emptyStateList) {
                                        <span class="required">*</span>
                                      }</label>
                                      <select id="inputcountry" class="form-select" [(ngModel)]="tdState" [disabled]="emptyStateList">
                                        <!--<option *ngIf="!emptyStateList" value="" selected i18n="@@Select">Select</option>-->
                                        @if (emptyStateList || tdState == 0) {
                                          <option value="0">--</option>
                                        }
                                        @for (st of stateList; track st) {
                                          <option [value]="st.Id">{{st.Name}}</option>
                                        }
                                      </select>
                                      @if (tdCountry && tdState =='') {
                                        <div>State is required.</div>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="row mt-3">
                                  @if (isMandatory('tdZip')) {
                                    <div class="form-group col-md-6">
                                      <label>Zip Code<span class="required">*</span></label>
                                      <input type="text" class="form-control" [(ngModel)]="tdZip" maxlength="15" required #zpc="ngModel"
                                        (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                        @if (zpc.errors && zpc.touched) {
                                          <div>
                                            @if (zpc.errors.required) {
                                              <div>Zip Code is required.</div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                    @if (isMandatory('tdCellphone')) {
                                      <div class="form-group col-md-6">
                                        <label>Cell Phone<span class="required">*</span></label>
                                        <ejs-maskedtextbox #cellphone [mask]="PhoneNumberMask" name="phone" id="inputCellPhone"
                                        [(ngModel)]="tdCellphone" required #cpn="ngModel" (change)="cellPhoneValidator($event)"></ejs-maskedtextbox>
                                        @if ((cpn.touched || cpn.dirty)) {
                                          <div>
                                            @if (cpn.errors && cpn.errors.required) {
                                              <div>Cell Phone is required.</div>
                                            }
                                            @if (cellphoneNotValid) {
                                              <div>Enter 10 digit Phone Number.</div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                  <div class="row mt-3">
                                    @if (isMandatory('tdEmail')) {
                                      <div class="form-group col-md-6">
                                        <label>Email<span class="required">*</span></label>
                                        <input type="text" class="form-control" [(ngModel)]="tdEmail" maxlength="64" [pattern]="emailIdsPattern"
                                          required #tdemail="ngModel" (ngModelChange)="onEmailEntered(tdemail)"
                                          (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                          @if (tdemail.errors && (tdemail.touched || tdemail.dirty)) {
                                            <div>
                                              @if (tdemail.errors.pattern) {
                                                <div>Email Id is not valid.</div>
                                              }
                                              @if (tdemail.errors.required) {
                                                <div>Email is required.</div>
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                              <div [ngClass]="fieldsRequired && customerInfoPresent? 'modal-footer autopay-footer' : 'modal-footer'">
                                @if (fieldsRequired && customerInfoPresent) {
                                  <label class="pure-material-checkbox float-left ">
                                    <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
                                      (change)="onClickAutoPopulateBillingInfo(208)">
                                      <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                                    </label>
                                  }

                                  <div class="pay_rgt_butt">
                                    <button type="button" class="btn btn-outline-primary me-3" (click)="ontTDHostedCancel()">Cancel</button>
                                    <button type="button" class="btn btn-primary" [disabled]="disableTDForm() || !isTDEmailValid || disableSaveButtonForTD"
                                    (click)="generateCCTAutopay()">{{CCPlaceHolder}}</button>
                                  </div>
                                </div>
                              </ng-template>

                              <ng-template #showTDchallengeForm>
                                <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalLabel">Payment Authentication</h5>
                                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="onTransactionCancel()">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <iframe class="custom-frame" id="three-d-frame" width="600" height="450" frameborder="0"
                                  name="threedframe"></iframe>
                                </div>
                                <div class="modal-footer">

                                </div>
                              </ng-template>

                              <ng-template #showAChHostedForm>
                                <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalLabel">Autopay / Card On File</h5>
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onAchHostedPageCancel()">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <form [formGroup]="autoAchForm" class="text-center">
                                    <div>
                                      <div class="form-group col-xs-6 has-feedback">
                                        <input type="text" class="form-control" formControlName="RoutingNumber" placeholder="Routing Number"
                                          maxlength="9">
                                        </div>
                                        <div class="form-group col-xs-6"></div>
                                      </div>
                                      <div>
                                        <div class="form-group col-xs-2 has-feedback">
                                          <input type="text" class="form-control" formControlName="AccountNumber" placeholder="Account Number"
                                            maxlength="15">
                                          </div>
                                          <div class="form-group col-xs-10"></div>
                                        </div>
                                        <div>
                                          <div class="form-group col-xs-2 has-feedback">
                                            <input type="text" class="form-control" formControlName="NameOnAccount" placeholder="Account Holder Name"
                                              maxlength="30">
                                            </div>
                                            <div class="form-group col-xs-10"></div>
                                          </div>
                                          <div>
                                            <div class="form-group col-xs-2 has-feedback">
                                              <select class="form-select" formControlName="ACHAccounttype" placeholder="Account Type">
                                                <option [value]="0" disabled="true" hidden>Select</option>
                                                @for (item of accounttype; track item) {
                                                  <option [value]="item.Id">{{item.Name}}</option>
                                                }
                                              </select>
                                            </div>
                                            <div class="form-group col-xs-10"></div>
                                          </div>
                                        </form>
                                        <div>
                                          <div class="row mx-0 mt-3">
                                            <h6>Customer Information:</h6>
                                          </div>
                                          <div class="row mt-3">
                                            <div class="form-group col-md-6">
                                              <label>First Name<span class="required">*</span></label>
                                              <input type="text" class="form-control" [(ngModel)]="achFirstName" maxlength="15" required #fnm="ngModel"
                                                (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                                @if (fnm.errors && fnm.touched) {
                                                  <div>
                                                    @if (fnm.errors.required) {
                                                      <div>First Name is required.</div>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                              <div class="form-group col-md-6">
                                                <label>Last Name<span class="required">*</span></label>
                                                <input type="text" class="form-control" [(ngModel)]="achLastName" maxlength="15" required #lnm="ngModel"
                                                  (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                                  @if (lnm.errors && lnm.touched) {
                                                    <div>
                                                      @if (lnm.errors.required) {
                                                        <div>Last Name is required.</div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                              <div class="row mt-3">
                                                <div class="form-group col-md-6">
                                                  <label>Address<span class="required">*</span></label>
                                                  <input type="text" class="form-control" [(ngModel)]="achAddress" maxlength="50" required #add="ngModel"
                                                    (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                                    @if (add.errors && add.touched) {
                                                      <div>
                                                        @if (add.errors.required) {
                                                          <div>Address is required.</div>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                  <div class="form-group col-md-6">
                                                    <label>City<span class="required">*</span></label>
                                                    <input type="text" class="form-control" [(ngModel)]="achCity" maxlength="15" required #noc="ngModel"
                                                      (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                                      @if (noc.errors && noc.touched) {
                                                        <div>
                                                          @if (noc.errors.required) {
                                                            <div>City is required.</div>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="row mt-3">
                                                    <div class="form-group col-md-6">
                                                      <label>Country<span class="required">*</span></label>
                                                      <select class="form-select" [(ngModel)]="achCountry" (change)="onCountryChange($event.target.value, 1)">
                                                        @for (ct of countryList; track ct) {
                                                          <option [value]="ct.Id">{{ct.Name}}</option>
                                                        }
                                                      </select>
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                      <label>State@if (!emptyStateList) {
                                                        <span class="required">*</span>
                                                      }</label>
                                                      <select class="form-select" [(ngModel)]="achState" [disabled]="emptyStateList">
                                                        @if (emptyStateList) {
                                                          <option value="0">--</option>
                                                        }
                                                        @for (st of stateList; track st) {
                                                          <option [value]="st.Id">{{st.Name}}</option>
                                                        }
                                                      </select>
                                                      @if (tdCountry && tdState =='') {
                                                        <div>State is required.</div>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div [ngClass]="customerInfoPresent? 'modal-footer autopay-footer' : 'modal-footer'">
                                                @if (customerInfoPresent) {
                                                  <label class="pure-material-checkbox float-left ">
                                                    <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
                                                      (change)="onClickAutoPopulateBillingInfo(456)">
                                                      <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                                                    </label>
                                                  }
                                                  <div class="pay_rgt_butt">
                                                    <button type="button" class="btn btn-outline-primary me-3" (click)="onAchHostedPageCancel()">Cancel</button>
                                                    <button type="button" (click)="createACHAlias()" class="btn btn-primary" [disabled]="disableAchForm()">{{achPlaceHolder}}</button>
                                                  </div>
                                                </div>
                                              </ng-template>

                                              <div bsModal #printReceiptPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
                                                aria-labelledby="dialog-sizes-name1">
                                                <div class="modal-dialog modal-dialog-centered modal-fullSize  modal-lg modal-xxl">
                                                  <div class="modal-content">
                                                    <div class="modal-header">
                                                      <h5 class="modal-title">Preview</h5>
                                                      <button type="button" class="close" (click)="printReceipt.hide()" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                      </button>
                                                    </div>
                                                    <div class="modal-body">
                                                      <div>
                                                        <iframe id="printf" #printf name="printf" style="width:100%; height:100%;">
                                                        </iframe>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <ng-template #templateDeleteAutopay>
                                                <div class="modal-header">
                                                  <h5 class="modal-title">Confirm</h5>
                                                  <button type="button" class="close pull-right" aria-label="Close" (click)="modalDeleteAutopay.hide()">
                                                    <span aria-hidden="true">&times;</span>
                                                  </button>
                                                </div>
                                                <div class="modal-body ptb24">
                                                  <p class="mb-0">
                                                    Are you sure you want to Delete Autopay?
                                                  </p>
                                                </div>
                                                <div class="modal-footer">
                                                  <button class="btn btn-outline-primary me-3" type="button" (click)="modalDeleteAutopay.hide()">No</button>
                                                  <button class="btn btn-primary" type="button" (click)="deleteAutopay()">Yes</button>
                                                </div>
                                              </ng-template>

                                              <ng-template #linkedAutopay>
                                                <div class="modal-header">
                                                  <h5 class="modal-title">Confirm</h5>
                                                  <button type="button" class="close pull-right" aria-label="Close" (click)="onClickLinkeAutopay(false)">
                                                    <span aria-hidden="true">&times;</span>
                                                  </button>
                                                </div>
                                                <div class="modal-body ptb24">
                                                  <p class="mb-0">Do you want to enable the same autopay for the following linked Rented Units?</p>
                                                  <ul>
                                                    @for (item of autopayLinledUnitList; track item) {
                                                      <li>{{ item.UnitNumber }}</li>
                                                    }
                                                  </ul>
                                                </div>
                                                <div class="modal-footer">
                                                  <button class="btn btn-outline-primary me-3" type="button" (click)="onClickLinkeAutopay(false)">No</button>
                                                  <button class="btn btn-primary" type="button" (click)="onClickLinkeAutopay(true)">Yes</button>
                                                </div>
                                              </ng-template>

                                              <ng-template #showStripePage>
                                                <app-stripe-payment [module]="2" [PublishableKey]="stripePublishableKey"
                                                  (emitStripeModalClose)="closeStripeModal($event)" [paymentMode]="selectedPaymentMode"
                                                  [mandatoryFieldsList]="mandatoryFieldsTD" [stripeClientSecret]="stripeClientSecret"
                                                  [UnifiedAccountId]="StripeUnifiedAccountId" [enableAddressAutofill]="enableAddressAutofill"
                                                  (emitConfirmaTokenResponse)="getConfirmationTokenData($event)"
                                                  (loaderStatus)="handleLoaderStatus($event)"
                                                [customerInfo]="customerInfoPresent ? customerInfo : null" [CCPlaceHolder]="CCPlaceHolder" [eftPlaceHolder]="eftPlaceHolder" [achPlaceHolder]="achPlaceHolder"></app-stripe-payment>
                                              </ng-template>

                                              <ng-template #selectStripeDevicePopup>
                                                <div class="modal-header">
                                                  <h5 class="modal-title">Select Device</h5>
                                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OnCardcancel()">
                                                    <span aria-hidden="true">&times;</span>
                                                  </button>
                                                </div>
                                                <div class="modal-body">
                                                  <div class="confirmation_det bg-white mx-auto w-100">
                                                    <label>Please select a Reader</label>
                                                    <select class="form-select" [(ngModel)]="selectStripeReaderId">
                                                      <option value="" disabled>Select</option>
                                                      @for (device of terminalDevicesList; track device) {
                                                        <option [value]="device.TerminalReaderId">{{device.Name}}
                                                        </option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="modal-footer">
                                                  <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                                  (click)="OnCardcancel()">Cancel</button>
                                                  <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="onSelectDevice()"
                                                  [disabled]="selectStripeReaderId == ''">Select</button>
                                                </div>
                                              </ng-template>
